import { gql } from "apollo-boost";

export const GET_ACTIVE_SPECIALITIES = gql`
  query activeSpecialitiesForAssociatedDoctor($where: SpecialityWhereInput) {
    specialities(where: $where) {
      id
      name
    }
  }
`;

export const GET_ASSOCIATED_DOCTOR_REQUEST_STATUS = gql`
  query associatedDoctorRequestStatus($where: AssociatedDoctorRequestStatusInput!) {
    associatedDoctorRequestStatus(where: $where) {
      sameChannelStatus
      canResubmit
      hasOtherChannelRequest
      message
      rejectedPreregistration {
        id
        firstName
        middleName
        lastName
        lastName2
        identificationCard
        documentType
        email
        phone
        phone2
        cellphone
        address
        provinceId
        municipalityId
        sectorId
        exequatur
        requestedProfileId
        requestedProviderId
        requestedBranchOfficeId
        specialities { id name }
        medicalSchedule { weekDay label fromHour toHour enabled }
        averageAppoimentTime
        documents { name size type requirementKey specialityId }
        documentRequirements { key label checked }
        status
        rejectionReason
      }
    }
  }
`;

export const USER_AND_MEDICAL = gql`
  query userAndMedical($where: userAndMedicalInput) {
    userAndMedical(where: $where) {
      id
      firstName
      lastName
      email
      identification
      documentTypeId
      username
      enabled
      averageAppoimentTime
      medicalSchedule {
        id
        weekDay
        fromHour
        toHour
        label
        enabled
      }
      profiles {
        id
        name
      }
      specialities {
        id
        name
      }
      medicalStaff {
        id
        name
        firstName
        middleName
        lastName
        lastName2
        username
        phone
        phone2
        cellphone
        email
        exequatur
        enabled
        identificationCard
        address
        municipalityId
        provinceId
        genderId
        sectorId
        legalPersonalityId
        userId
      }
    }
  }
`;
export const VALIDATE_USER_EXIST = gql`
  query validateUser($where: validateUserInput) {
    validateUser(where: $where) {
      id
    }
  }
`;
export const GET_MEDICAL_BY_BRANCH = gql`
  query getMedicalByBranch($where: getMedicalByBranchI) {
    getMedicalByBranch(where: $where) {
      medicalStaffId
      branchOfficeId
      medicalStaffName
      nameSpeciality
      doctorSecretaryId
    }
  }
`;

export const GET_DOCTOR_SECRETARY = gql`
  query getDoctorSecretary($where: doctorSecretaryI) {
    getDoctorSecretary(where: $where) {
      id
      medicalStaffId
      branchOfficeId
      medicalStaffName
      nameSpeciality
      userId
      enabled
      validateAppointmentExist
      wasEliminated
    }
  }
`;
